import type { PublicSlotKey } from '#packages/apilib';
import type { DeprecationOverlayApi } from './api';

export const DeprecationOverlayApiKey: PublicSlotKey<DeprecationOverlayApi> = {
  name: 'deprecationOverlayApi',
  public: true,
};
